import '../assets/SimpleSpinner.css';const n = "op_spinner_NaddM", t = {
  spinner: n
};
function r(e) {
  return e.on ? /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("span", { className: t.spinner })) : [];
}
export {
  r as SimpleSpinner
};
